import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
import engagementDashboardReducer from "./reducer/engagementDashboardReducer";
import upcomingMeetingReducer from "./reducer/upcomingMeetingReducer";
import expiringLeadsReducer from "./reducer/expiringLeadsReducer";
import engagementDashboardStatusReducer from "./reducer/engagementDashboardStatusReducer";
import upcomingEventsReducer from "./reducer/upcomingEventsReducer";
export default combineReducers({
    upcomingEvents: createNamedWrapperReducer(upcomingEventsReducer, "upcomingEvents"),
    upcomingMeetings: createNamedWrapperReducer(upcomingMeetingReducer, "upcomingMeetings"),
    expiringLeads: createNamedWrapperReducer(expiringLeadsReducer, "expiringLeads"),
    engagementDashboard: createNamedWrapperReducer(engagementDashboardReducer, "engagementDashboard"),
    engagementDashboardStatus: createNamedWrapperReducer(engagementDashboardStatusReducer, "engagementDashboardStatus"),
});
